<template>
  <div>
    <router-view key="PermittingModule" />
  </div>
</template>
<script>

export default {
  name: 'PermitsModule',
};
</script>
